import Api from './Api';

/**
 * Fornece acesso às APIs de Health Check de todos os Backends utilizados.
 */
class HealthCheckApi extends Api {
    async backendSessao() {
        let backendSessao = await this.fetch(this.configuracao.urlHealthCheckSessao).catch((e) => {
            throw new Error(e.message);
        });
        return backendSessao.data;
    }

    async getVariaveis() {
        return this.consultarParametrosBuild();
    }
}

export default HealthCheckApi;
